import * as s from './DropDownContent.module.scss'

export const getDropDownContainer = () => document.querySelectorAll(`.${s.portalDropDown}`)
